import React from 'react';
import { IconInfoFilled } from '@components/icons';
import { PopoverTextWrapper } from '@components/tooltip/src/component/popover-text-wrapper';
import { Tooltip } from '@components/tooltip/src/tooltip';
import classNames from 'classnames';

import { Label } from './label';
import { LabelInfoProps } from './label.types';

export const LabelInfo = ({
  text,
  children,
  ariaLabel,
  className,
  hasError,
  customColors,
  isBold,
  marginBottomClassName = 'mb-2',
  ...props
}: LabelInfoProps) => {
  return (
    <div className='flex flex-row items-start whitespace-nowrap'>
      <div className={classNames(className, 'flex flex-row items-center')}>
        <Label
          className={classNames(
            {
              'text-critical': hasError,
              'text-primary': !hasError && !customColors,
              'text-headline-l': isBold,
              'text-body-xs': !isBold,
            },
            !hasError && customColors ? customColors : undefined,
            marginBottomClassName as string
          )}
          {...props}>
          {children}
        </Label>
      </div>
      <div className='ml-2 flex justify-center items-center relative'>
        <Tooltip
          ariaLabel={ariaLabel}
          buttonClasses='flex items-start'
          button={
            <IconInfoFilled
              className={classNames('', {
                'w-5 h-5 text-secondary': isBold,
                'w-3 h-3 text-tertiary': !isBold,
              })}
            />
          }
          popoverContent={<PopoverTextWrapper>{text}</PopoverTextWrapper>}
        />
      </div>
    </div>
  );
};
